import { render, staticRenderFns } from "./update-phone.component.vue?vue&type=template&id=31b21c14&"
import script from "./update-phone.component.vue?vue&type=script&lang=ts&"
export * from "./update-phone.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports